import ReviewsCarousel from './ReviewsCarousel';
export default ReviewsCarousel;
